import {Stack, Typography} from '@mui/material';
import React from 'react';
import {useServicesList} from 'presentation/pages/private/hooks/useServicesList';
import {translations} from 'presentation/translations-new';
import {ServiceCategory} from '../ServiceCategory';
import {OtherServicesProps} from './types';
import {FeaturesEnum} from 'presentation/constants';
import {useFeatureFlag} from 'presentation/hooks/useFeatureFlag';
import {OtherServicesContainer} from './styles';
import {useSideBarOpenStateStore} from 'presentation/pages/private/store/sideBarOpenStateStore';

const {otherServices} = translations['pt-br'].privateFlow.services;

export function OtherServices({query}: OtherServicesProps) {
	const isSideBarOpenState = useSideBarOpenStateStore(state => state.sideBarOpenState);
	const {
		healthAppointmentsServices,
		odontoAppointmentsServices,
		financialAndDocsServices,
		perksServices,
		portabilityAndPermanenceServices,
		supportServices,
		managementServices,
		firstColumnIsEmpty,
		secondColumnIsEmpty,
		thirdColumnIsEmpty,
	} = useServicesList(query);

	const {isEnabled: isAccordionServicesFeatureFlagEnabled} = useFeatureFlag(
		FeaturesEnum.PORTAL_FEATURE_ACCORDION_SERVICES,
	);

	const {isEnabled: isHelpServicesPositionFeatureFlagEnabled} = useFeatureFlag(
		FeaturesEnum.PORTAL_FEATURE_HELP_SERVICES_POSITION,
	);

	return (
		<Stack gap={1}>
			<Typography variant="subtitle1" color="text.secondary" fontWeight={700}>
				{otherServices}
			</Typography>

			<Stack
				gap={2}
				component={isAccordionServicesFeatureFlagEnabled ? Stack : OtherServicesContainer}
				{...(!isAccordionServicesFeatureFlagEnabled && {
					$sidebarIsOpen: isSideBarOpenState,
				})}>
				{isHelpServicesPositionFeatureFlagEnabled && (
					<ServiceCategory serviceCategory={supportServices} />
				)}

				{!firstColumnIsEmpty && (
					<Stack gap={1.5}>
						<ServiceCategory serviceCategory={healthAppointmentsServices} />
						<ServiceCategory serviceCategory={odontoAppointmentsServices} />
						<ServiceCategory serviceCategory={financialAndDocsServices} />
					</Stack>
				)}

				{!thirdColumnIsEmpty && isAccordionServicesFeatureFlagEnabled && (
					<Stack gap={1.5}>
						<ServiceCategory serviceCategory={managementServices} />
					</Stack>
				)}

				{!secondColumnIsEmpty && (
					<Stack gap={1.5}>
						<Stack
							gap={1.5}
							flexDirection={
								isAccordionServicesFeatureFlagEnabled ? 'column' : 'column-reverse'
							}>
							<ServiceCategory serviceCategory={perksServices} />
							<ServiceCategory serviceCategory={portabilityAndPermanenceServices} />
						</Stack>
						{!isHelpServicesPositionFeatureFlagEnabled && (
							<ServiceCategory serviceCategory={supportServices} />
						)}
					</Stack>
				)}

				{!thirdColumnIsEmpty && !isAccordionServicesFeatureFlagEnabled && (
					<Stack gap={1.5}>
						<ServiceCategory serviceCategory={managementServices} />
					</Stack>
				)}
			</Stack>
		</Stack>
	);
}
